import { isRecord } from "../lib/records";

type OrderedMessage = {
  readonly value: unknown;
  readonly index: number;
};

function numberField(value: unknown, key: string): number | undefined {
  if (!isRecord(value) || typeof value[key] !== "number") return undefined;
  return value[key];
}

function stringField(value: unknown, key: string): string | undefined {
  if (!isRecord(value) || typeof value[key] !== "string") return undefined;
  return value[key];
}

function compareMessages(left: OrderedMessage, right: OrderedMessage): number {
  const leftOrder = numberField(left.value, "order");
  const rightOrder = numberField(right.value, "order");
  if (leftOrder !== undefined && rightOrder !== undefined && leftOrder !== rightOrder) {
    return leftOrder - rightOrder;
  }

  const leftStep = numberField(left.value, "stepOrder");
  const rightStep = numberField(right.value, "stepOrder");
  if (leftStep !== undefined && rightStep !== undefined && leftStep !== rightStep) {
    return leftStep - rightStep;
  }

  const leftCreated = numberField(left.value, "_creationTime");
  const rightCreated = numberField(right.value, "_creationTime");
  if (leftCreated !== undefined && rightCreated !== undefined && leftCreated !== rightCreated) {
    return leftCreated - rightCreated;
  }

  const leftId = stringField(left.value, "_id");
  const rightId = stringField(right.value, "_id");
  if (leftId !== undefined && rightId !== undefined && leftId !== rightId) {
    return leftId.localeCompare(rightId);
  }

  return left.index - right.index;
}

export function normalizeChatMessages<T>(messages: readonly T[]): T[] {
  return messages
    .map((value, index) => ({ value, index }))
    .sort(compareMessages)
    .map(({ value }) => value);
}
